import { render, staticRenderFns } from "./Instalations.vue?vue&type=template&id=267bc51b&"
import script from "./Instalations.vue?vue&type=script&lang=js&"
export * from "./Instalations.vue?vue&type=script&lang=js&"
import style0 from "./Instalations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports